/*
 * Back in stock + made-to-order quote requests (Klaviyo) — replaces Appikon, Oct 2026.
 * Data comes from snippets/cra-restock.liquid. Listens for the theme's own "variant:changed" event (fired after the
 * theme has set the Add to cart / Pre Order / Sold out button) and shows our button or link for that size.
 * Submitting sends a Klaviyo client event ("CRA Restock Request" or "CRA Quote Request") with the public key, and, when
 * the box is ticked (or on the SMS tab), subscribes the profile to the "Back in Stock opt-in" list. The hourly back-in-stock job in the CRA
 * repo (scripts/back-in-stock/run.mjs) reads those events and sends the emails. Nothing here touches the cart.
 */
(function () {
  'use strict';
  // Warehouse 7.0.1 replaces the payment container (and this root) on every size change. One module serves every
  // root on the page; loading the file again only re-scans. 2.6.6 still works through variant:changed.
  if (window.craRestock) { window.craRestock.scan(); return; }
  window.craRestock = { scan: scan };
  var D = null, root = null, main = null, link = null, form = document, current = null;
  var REV = '2025-10-15';
  var NOTIFY = { pre: 1, inc: 1, mto: 1, sold: 1 };
  var MONTHS = 'January February March April May June July August September October November December'.split(' ');
  function use(r) {                       // make r the active root
    if (!r.__craRs) { try { r.__craRs = JSON.parse(r.querySelector('[data-cra-rs-json]').textContent); } catch (e) { return false; } }
    root = r; D = r.__craRs; main = r.querySelector('[data-cra-rs-main]'); link = r.querySelector('[data-cra-rs-link]');
    form = r.closest('form') || document; current = r.__craRsCurrent || String(D.selected);
    return true;
  }
  function scan() {
    document.querySelectorAll('[data-cra-rs]:not([data-ready])').forEach(function (r) {
      r.setAttribute('data-ready', '1');
      if (use(r)) update(current);         // bis_cta_view is de-duplicated by the module-level `seen`
    });
  }

  /* ------------------------------------------------------------ helpers */
  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) { if (attrs[k] === true) n.setAttribute(k, ''); else if (attrs[k] !== false && attrs[k] != null) n.setAttribute(k, attrs[k]); }
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function size(t) { var m = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i.exec(t || ''); return m ? m[1] + ' x ' + m[2] + ' cm' : (t || ''); }
  // "Due back into stock November 25th" -> "25 November"
  function dateOf(msg) {
    var m = /(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{1,2})/i.exec(msg || '');
    return m ? m[2] + ' ' + MONTHS[MONTHS.map(function (x) { return x.toLowerCase(); }).indexOf(m[1].toLowerCase())] : '';
  }
  function rugName() { return String(D.product.title || '').replace(/\s+Rug$/i, ''); }
  function variant(id) { return D.variants[String(id)] || null; }
  /* Analytics: every event goes to the dataLayer as "bis_<what>" with flat bis_* fields; GTM forwards them all to GA4
   * (tag "GA4 - Event - Back in Stock"). Events: bis_cta_view (button/link shown for a size, once per size per page),
   * bis_open, bis_size_change, bis_channel_select, bis_optin_toggle, bis_submit_error (didn't pass the form check),
   * bis_request (sent), bis_send_fail (Klaviyo refused), bis_change_details, bis_close (how, at which step, seconds open). */
  var cta = 'button', openedAt = 0, seen = {};
  function track(name, vid, extra) {
    var v = vid ? variant(vid) : null;
    var data = { bis_mode: mode, bis_cta: cta, bis_product_id: String(D.product.id), bis_product_title: D.product.title,
      bis_vendor: D.product.vendor || '', bis_product_type: D.product.type || '', bis_variant_id: vid ? String(vid) : '',
      bis_size: v ? size(v.t) : '', bis_sku: v ? v.k || '' : '', bis_state: v ? v.s : '', bis_price: v && v.p != null ? Number(v.p) : null,
      bis_channel: chan, bis_sms_offered: !!D.sms };
    Object.assign(data, extra || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(D.key), {
      method: 'POST', headers: { 'content-type': 'application/json', revision: REV }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status); return r; });
  }
  function profileOf(attrs) { return { data: { type: 'profile', attributes: attrs } }; }
  function event(metric, profile, props) {
    return post('events', { data: { type: 'event', attributes: {
      properties: props, metric: { data: { type: 'metric', attributes: { name: metric } } }, profile: profileOf(profile) } } });
  }

  /* ------------------------------------------------------------ the button and link under the buy button */
  function update(id) {
    current = id == null ? null : String(id);
    if (root) root.__craRsCurrent = current;
    var v = current ? variant(current) : null;
    var isMain = !!(v && NOTIFY[v.s] && !v.b);
    var addBtn = form.querySelector('.product-form__add-button');
    main.hidden = !isMain;
    root.classList.toggle('is-main', isMain);
    if (addBtn) addBtn.classList.toggle('cra-rs-off', isMain);
    if (v && v.s === 'quote') { link.textContent = 'Ask about having it made'; link.hidden = false; }
    else if (v && NOTIFY[v.s] && v.b) { link.textContent = "Not ready? Tell me when it's back in stock"; link.hidden = false; }
    else link.hidden = true;
    root.hidden = main.hidden && link.hidden;
    if (!root.hidden && current && !seen[current]) {
      seen[current] = 1;
      mode = v.s === 'quote' ? 'quote' : 'notify'; cta = isMain ? 'button' : v.s === 'quote' ? 'quote_link' : 'link';
      track('bis_cta_view', current);
    }
  }
  document.addEventListener('variant:changed', function (e) {   // 2.6.6: the theme patches the page in place
    if (!root || !root.isConnected || !e.target || !e.target.contains || !e.target.contains(root)) return;
    update(e.detail && e.detail.variant ? e.detail.variant.id : null);
  });
  document.addEventListener('product:rerender', function () { setTimeout(scan, 0); }, true);   // 7.0.1: new root
  document.addEventListener('click', function (e) {           // delegated: the buttons are re-rendered
    var b = e.target.closest && e.target.closest('[data-cra-rs-main], [data-cra-rs-link]');
    var r = b && b.closest('[data-cra-rs]');
    if (!r || !use(r)) return;
    if (b.hasAttribute('data-cra-rs-main')) { cta = 'button'; open('notify'); }
    else { var v = variant(current), q = !!(v && v.s === 'quote'); cta = q ? 'quote_link' : 'link'; open(q ? 'quote' : 'notify'); }
  });

  /* ------------------------------------------------------------ pop-up */
  var pop, mode = 'notify', chan = 'email', lastFocus = null;
  function formVid() { return pop ? $(mode === 'quote' ? 'qsize' : 'size').value : current; }
  var $ = function (id) { return pop.querySelector('[data-id="' + id + '"]'); };

  function build() {
    pop = el('div', { class: 'cra-pop', hidden: true, role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'cra-pop-h' });
    pop.innerHTML =
      '<form class="cra-pop__box" novalidate>' +
        '<button type="button" class="cra-pop__x" data-id="x" aria-label="Close">&times;</button>' +
        '<input class="cra-pop__hp" data-id="hp" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<div data-id="notify">' +
          '<h5 id="cra-pop-h">Tell me when it\'s back</h5>' +
          '<p class="cra-pop__sub">We\'ll let you know as soon as this size is back in stock.</p>' +
          '<p class="cra-pop__rug">' + esc(D.product.title) + '</p>' +
          '<label class="cra-pop__vh" for="cra-pop-size">Size</label>' +
          '<select class="cra-pop__sel" id="cra-pop-size" data-id="size"></select>' +
          '<div class="cra-pop__ctx" data-id="ctx"></div>' +
          '<div class="cra-pop__tabs" data-id="tabs" role="group" aria-label="How should we tell you?"' + (D.sms ? '' : ' hidden') + '>' +
            '<button type="button" class="cra-pop__tab" data-id="t-email" aria-pressed="true">Email</button>' +
            '<button type="button" class="cra-pop__tab" data-id="t-sms" aria-pressed="false">SMS</button>' +
          '</div>' +
          '<label class="cra-pop__vh" for="cra-pop-email">Email address</label>' +
          '<input class="cra-pop__in" id="cra-pop-email" data-id="email" type="email" placeholder="Email address" autocomplete="email" inputmode="email">' +
          '<label class="cra-pop__vh" for="cra-pop-phone">Mobile number</label>' +
          '<input class="cra-pop__in" id="cra-pop-phone" data-id="phone" type="tel" placeholder="Mobile number, e.g. 0412 345 678" autocomplete="tel" hidden>' +
          '<div class="cra-pop__err" data-id="err" role="alert" hidden></div>' +
          '<button type="submit" class="cra-pop__go" data-id="go">Notify me</button>' +
          '<label class="cra-pop__chk" data-id="chkwrap"><input type="checkbox" data-id="optin" checked><span>Also send me new arrivals and the occasional offer</span></label>' +
          '<p class="cra-pop__disc" data-id="smsdisc" hidden>By tapping Notify me you agree to receive a text from Cheap Rugs Australia when this size is back, plus occasional marketing texts. Reply STOP to opt out. Message rates may apply.</p>' +
          '<p class="cra-pop__fine">We respect your privacy and don\'t share your details with anybody.</p>' +
        '</div>' +
        '<div data-id="quote" hidden>' +
          '<h5>Ask about having it made</h5>' +
          '<p class="cra-pop__sub">This design has been discontinued, but it may be possible to have it made to order. It\'s priced by quote and currently takes about 5 to 6 months. Leave your details and we\'ll get you a quote.</p>' +
          '<p class="cra-pop__rug">' + esc(D.product.title) + '</p>' +
          '<label class="cra-pop__vh" for="cra-pop-qsize">Size</label>' +
          '<select class="cra-pop__sel" id="cra-pop-qsize" data-id="qsize"></select>' +
          '<label class="cra-pop__vh" for="cra-pop-qname">Your name</label>' +
          '<input class="cra-pop__in" id="cra-pop-qname" data-id="qname" placeholder="Your name" autocomplete="name">' +
          '<label class="cra-pop__vh" for="cra-pop-qemail">Email address</label>' +
          '<input class="cra-pop__in" id="cra-pop-qemail" data-id="qemail" type="email" placeholder="Email address" autocomplete="email" inputmode="email">' +
          '<label class="cra-pop__vh" for="cra-pop-qnote">Anything we should know</label>' +
          '<textarea class="cra-pop__ta" id="cra-pop-qnote" data-id="qnote" maxlength="1000" placeholder="Anything we should know? (optional)"></textarea>' +
          '<div class="cra-pop__err" data-id="qerr" role="alert" hidden></div>' +
          '<button type="submit" class="cra-pop__go" data-id="qgo">Get a quote</button>' +
          '<p class="cra-pop__fine">We\'ll reply by email. We respect your privacy and don\'t share your details with anybody.</p>' +
        '</div>' +
        '<div class="cra-pop__done" data-id="done" hidden>' +
          '<div class="cra-pop__tick" aria-hidden="true">&#10003;</div>' +
          '<h6 data-id="doneh">You\'re on the list</h6>' +
          '<p data-id="donetxt"></p>' +
          '<button type="button" class="cra-pop__go" data-id="close2">Keep browsing</button>' +
          '<button type="button" class="cra-pop__again" data-id="again">Change details</button>' +
        '</div>' +
      '</form>';
    document.body.appendChild(pop);

    $('x').addEventListener('click', function () { close('x'); });
    $('close2').addEventListener('click', function () { close('keep_browsing'); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close('backdrop'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close('escape'); });
    $('again').addEventListener('click', function () { $('done').hidden = true; $(mode === 'quote' ? 'quote' : 'notify').hidden = false; track('bis_change_details', formVid()); });
    $('size').addEventListener('change', function () { $('ctx').innerHTML = ctxFor(variant(this.value)); track('bis_size_change', this.value); });
    $('qsize').addEventListener('change', function () { track('bis_size_change', this.value); });
    $('t-email').addEventListener('click', function () { if (chan !== 'email') { chan = 'email'; renderChan(); track('bis_channel_select', formVid()); } });
    $('t-sms').addEventListener('click', function () { if (chan !== 'sms') { chan = 'sms'; renderChan(); track('bis_channel_select', formVid()); } });
    $('optin').addEventListener('change', function () { track('bis_optin_toggle', formVid(), { bis_opt_in: this.checked }); });
    pop.querySelector('form').addEventListener('submit', submit);
  }

  function label(v) {
    var d = dateOf(v.m).replace(/^(\d+) (\w{3})\w*$/, '$1 $2');
    return size(v.t) + ' · ' + ({ pre: 'pre-order', inc: d ? 'expected back ' + d : 'expected back', sold: 'sold out', mto: 'made to order' }[v.s] || '');
  }
  function ctxFor(v) {
    if (!v) return '';
    var d = dateOf(v.m);
    if (v.s === 'pre' && d) return '<b>Due back around ' + esc(d) + '.</b> You can pre-order now and we\'ll send it when it lands, or we\'ll let you know the day it\'s back.';
    if (v.s === 'pre') return '<b>Re-stocking soon.</b> You can pre-order now and we\'ll send it when it lands, or we\'ll let you know the day it\'s back.';
    if (v.s === 'inc') return '<b>Expected back' + (d ? ' around ' + esc(d) : ' soon') + '.</b> We\'ll let you know the day it\'s back. Want one held? Just reply to our confirmation email.';
    if (v.s === 'mto') return '<b>This size is made to order,</b> currently about 5 to 6 months. You can order it now, or we\'ll let you know if stock arrives sooner.';
    return '<b>No date yet.</b> We\'ll let you know the moment it\'s back.';
  }
  function options(select, want) {
    select.innerHTML = '';
    var first = null;
    for (var id in D.variants) {
      var v = D.variants[id];
      if (!want(v)) continue;
      var o = el('option', { value: id }, esc(want === isQuote ? size(v.t) : label(v)));
      if (id === current) o.selected = true;
      if (!first) first = o;
      select.appendChild(o);
    }
    if (!select.value && first) first.selected = true;
  }
  function isNotify(v) { return !!NOTIFY[v.s]; }
  function isQuote(v) { return v.s === 'quote'; }
  function renderChan() {
    $('t-email').setAttribute('aria-pressed', String(chan === 'email'));
    $('t-sms').setAttribute('aria-pressed', String(chan === 'sms'));
    $('email').hidden = chan !== 'email'; $('phone').hidden = chan !== 'sms';
    $('smsdisc').hidden = chan !== 'sms'; $('chkwrap').hidden = chan !== 'email'; $('err').hidden = true;
  }
  function open(m) {
    if (!pop) build();
    mode = m; if (!D.sms) chan = 'email';
    lastFocus = document.activeElement;
    $('err').hidden = true; $('qerr').hidden = true; $('done').hidden = true;
    $('notify').hidden = m !== 'notify'; $('quote').hidden = m !== 'quote';
    if (m === 'notify') { options($('size'), isNotify); $('ctx').innerHTML = ctxFor(variant($('size').value)); renderChan(); }
    else options($('qsize'), isQuote);
    pop.hidden = false;
    document.documentElement.classList.add('cra-pop-open');
    setTimeout(function () { var f = m === 'notify' ? $(chan === 'sms' ? 'phone' : 'email') : $('qname'); if (f) f.focus(); }, 30);
    openedAt = Date.now();
    track('bis_open', formVid());
  }
  function close(how) {
    if (!pop || pop.hidden) return;
    track('bis_close', formVid(), { bis_close_how: how || 'other', bis_close_step: $('done').hidden ? 'form' : 'done',
      bis_seconds_open: openedAt ? Math.round((Date.now() - openedAt) / 1000) : null });
    pop.hidden = true;
    document.documentElement.classList.remove('cra-pop-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function busy(btn, on) { btn.disabled = on; }
  function failed(errEl, btn, vid, err) {
    track('bis_send_fail', vid, { bis_error: String(err && err.message || err || 'unknown').slice(0, 100) });
    errEl.innerHTML = 'Sorry, that didn\'t go through. Please try again, or email us at <a href="mailto:info@cheaprugsaustralia.com.au">info@cheaprugsaustralia.com.au</a>.';
    errEl.hidden = false; busy(btn, false);
  }
  function done(h, txt) {
    $('doneh').textContent = h; $('donetxt').innerHTML = txt;
    $('notify').hidden = true; $('quote').hidden = true; $('done').hidden = false;
    $('close2').focus();
  }

  function submit(e) {
    e.preventDefault();
    var bot = !!$('hp').value; // honeypot: bots fill every field; show success, send nothing
    var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;
    var base = { product_id: D.product.id, product_title: D.product.title, product_url: location.origin + D.product.url,
      vendor: D.product.vendor, page_url: location.href.split('#')[0], source: 'product page' };

    if (mode === 'quote') {
      var name = $('qname').value.trim(), qe = $('qemail').value.trim(), note = $('qnote').value.trim().slice(0, 1000);
      var qid = $('qsize').value, qv = variant(qid);
      if (!name || !EMAIL.test(qe)) { $('qerr').textContent = 'Please enter your name and a valid email address.'; $('qerr').hidden = false;
        track('bis_submit_error', qid, { bis_error: !name && !qe ? 'empty_form' : !name ? 'missing_name' : qe ? 'invalid_email' : 'missing_email' }); return; }
      $('qerr').hidden = true; busy($('qgo'), true);
      var parts = name.split(/\s+/), first = parts.shift(), last = parts.join(' ');
      var okQ = function () {
        busy($('qgo'), false);
        track('bis_request', qid, { bis_channel: 'email', bis_opt_in: false, bis_has_note: !!note, bis_bot: bot });
        done('Thanks, ' + esc(first), 'We\'ve passed your quote request for the ' + esc(size(qv.t)) + ' ' + esc(D.product.title) + ' to our team. We\'ll email <b>' + esc(qe) + '</b> with a price and timing once we\'ve checked with the maker.');
      };
      if (bot) return okQ();
      var profile = { email: qe, first_name: first };
      if (last) profile.last_name = last;
      event('CRA Quote Request', profile, Object.assign({ variant_id: Number(qid), size: size(qv.t), state: 'quote', message: qv.m, name: name, note: note }, base))
        .then(okQ, function (err) { failed($('qerr'), $('qgo'), qid, err); });
      return;
    }

    var vid = $('size').value, v = variant(vid);
    var val = chan === 'email' ? $('email').value.trim() : $('phone').value.replace(/[\s()-]/g, '');
    var ok = chan === 'email' ? EMAIL.test(val) : /^(\+?61|0)4\d{8}$/.test(val);
    if (!ok) { $('err').textContent = chan === 'email' ? 'Please enter a valid email address.' : 'Please enter an Australian mobile number.'; $('err').hidden = false;
      track('bis_submit_error', vid, { bis_error: !val ? 'empty_' + chan : chan === 'email' ? 'invalid_email' : 'invalid_mobile' }); return; }
    $('err').hidden = true; busy($('go'), true);
    var phone = chan === 'sms' ? '+61' + val.replace(/^(\+?61|0)/, '') : null;
    var optin = chan === 'email' && $('optin').checked;
    var nm = size(v.t) + ' ' + rugName();
    var extra = { pre: ' We\'ve sent a confirmation with the expected date and a link to pre-order if you\'d rather not wait.',
      inc: ' We\'ve sent a confirmation with the expected date. Reply to it if you\'d like one held.',
      mto: ' We\'ve sent a confirmation with how made to order works.', sold: ' We\'ve sent a confirmation to your inbox.' }[v.s] || '';
    var okN = function () {
      busy($('go'), false);
      track('bis_request', vid, { bis_opt_in: optin, bis_bot: bot });
      done('You\'re on the list', chan === 'email'
        ? 'We\'ll email <b>' + esc(val) + '</b> when the <b>' + esc(size(v.t)) + '</b> ' + esc(rugName()) + ' is back.' + extra
        : 'We\'ll text you when the <b>' + esc(size(v.t)) + '</b> ' + esc(rugName()) + ' is back.');
    };
    if (bot) return okN();
    var profile = chan === 'email' ? { email: val } : { phone_number: phone };
    var calls = [event('CRA Restock Request', profile, Object.assign({ variant_id: Number(vid), size: size(v.t), state: v.s, message: v.m,
      channel: chan, opt_in: optin, rug: nm }, base))];
    var subs = null;
    if (optin) subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (chan === 'sms') subs = { sms: { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } } };
    if (subs) {
      var pa = Object.assign({}, profile, { subscriptions: subs });
      // A failed opt-in never blocks the request itself.
      calls.push(post('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Back in Stock', profile: profileOf(pa) },
        relationships: { list: { data: { type: 'list', id: D.list } } } } }).catch(function (err) { track('bis_optin_fail', vid, { bis_error: String(err && err.message || err).slice(0, 100) }); }));
    }
    Promise.all(calls).then(okN, function (err) { failed($('err'), $('go'), vid, err); });
  }

  scan();
})();
